import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { PreloadAllModules, provideRouter, withPreloading, withRouterConfig } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import Lara from '@primeng/themes/lara';
import { SigepeMainLayoutModule } from '@sigepe/sigepe-template';
import { SigepeSegurancaModule } from '@sigepe/ngx-sigepe-seguranca';
import { TitleCasePipe } from '@angular/common';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { routes } from './app.routes';

export function httpTranslateLoader(http: HttpClient): TranslateHttpLoader {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(routes, withPreloading(PreloadAllModules), withRouterConfig({ onSameUrlNavigation: 'reload' })),
		importProvidersFrom(
			BrowserModule,
			SigepeSegurancaModule.forRoot(environment.SEGURANCA_CONFIG),
			SigepeMainLayoutModule.forRoot(environment),
			TranslateModule.forRoot({
				loader: {
					provide: TranslateLoader,
					useFactory: httpTranslateLoader,
					deps: [HttpClient]
				}
			})
		),
		Title,
		TitleCasePipe,
		{ provide: HTTP_INTERCEPTORS, useClass: environment.PROVIDER_AUTH, multi: true },
		provideAnimationsAsync(),
		providePrimeNG({
			theme: {
				preset: Lara,
				options: {
					// importante p/ conviver com Tailwind/outros CSS utilitários;
					// garante que o CSS do tema PrimeNG fique numa camada de menor prioridade
					darkModeSelector: '.app-dark'
				}
			}
		})
	]
};
